import { defineStore } from 'pinia';
import SubmitWorksheetService from '@/service/SubmitWorksheetService';

export const useSubmitWorksheetStore = defineStore('submitWorksheetStore', {
  state: () => ({
    currentWorkSheet: {}
  }),
  getters: {
    getCurrentWorkSheet: (state) => state.currentWorkSheet
  },
  actions: {
    handleUpdateWorkSheet(payload: any, id: any) {
      const submitWorkSheetService = new SubmitWorksheetService();
      return submitWorkSheetService.handleSubmit(payload, id);
    },

    updatePassengers(payload: any, id: any) {
      const submitWorkSheetService = new SubmitWorksheetService();
      return submitWorkSheetService.updatePassengers(payload, id);
    },

    updateRohRoom(payload: any) {
      const submitWorkSheetService = new SubmitWorksheetService();
      return submitWorkSheetService.updateRohRoom(payload);
    }
  }
});
